/* Nyluno storefront behaviour: header, drawers, real Shopify cart, carousels, accordions,
   product variant selection, gallery + lightbox, sticky purchase bar, newsletter validation. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  root.classList.remove('nyl-no-js'); root.classList.add('nyl-js');
  if (reduce || design) root.classList.add('nyl-no-motion');
  var cfg = window.NylConfig || {};

  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function on(el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o || false); }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    format = format || cfg.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    function fmt(n, p, t, dec) {
      p = p == null ? 2 : p; t = t || ','; dec = dec || '.';
      var num = (n / 100).toFixed(p).split('.');
      var dollars = num[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      return dollars + (num[1] ? dec + num[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/), v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  window.NylFormatMoney = formatMoney;

  /* ---------- Toast / live region ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = d.createElement('div'); toastEl.className = 'nyl-toast'; toastEl.setAttribute('role', 'status'); d.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(scope) {
    var els = $$('.nyl-rv:not(.is-in)', scope);
    if (!els.length) return;
    if (reduce || design || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
    // Safety net: never leave content hidden if an observer misses it.
    setTimeout(function () { els.forEach(function (e) { if (e.getBoundingClientRect().top < window.innerHeight) e.classList.add('is-in'); }); }, 1500);
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var hdr = $('[data-nyl-header]');
    if (!hdr || hdr._nyl) return; hdr._nyl = 1;
    function setH() { root.style.setProperty('--nyl-hh', hdr.offsetHeight + 'px'); }
    function onScroll() { hdr.classList.toggle('is-solid', window.scrollY > 24); }
    setH(); onScroll();
    on(window, 'scroll', onScroll, { passive: true });
    on(window, 'resize', setH);
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(hdr);
  }

  /* ---------- Drawers ---------- */
  var openDrawer = null, lastFocus = null;
  function focusables(el) { return $$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', el).filter(function (x) { return x.offsetParent !== null; }); }
  function open(name, opener) {
    var dr = d.getElementById('nyl-drawer-' + name);
    if (!dr) return false;
    if (openDrawer && openDrawer !== dr) close();
    lastFocus = opener || d.activeElement;
    dr.classList.add('is-open'); dr.setAttribute('aria-hidden', 'false');
    $$('[data-nyl-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    d.body.style.overflow = 'hidden'; openDrawer = dr;
    setTimeout(function () { var f = focusables($('.nyl-drawer__panel', dr)); if (f[0]) f[0].focus(); }, 60);
    d.dispatchEvent(new CustomEvent('nyl:drawer', { detail: { name: name, open: true } }));
    return true;
  }
  function close() {
    if (!openDrawer) return;
    var name = openDrawer.id.replace('nyl-drawer-', '');
    openDrawer.classList.remove('is-open'); openDrawer.setAttribute('aria-hidden', 'true');
    $$('[data-nyl-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    d.body.style.overflow = ''; openDrawer = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    d.dispatchEvent(new CustomEvent('nyl:drawer', { detail: { name: name, open: false } }));
  }
  window.NylDrawer = { open: open, close: close };
  on(d, 'click', function (e) {
    var o = e.target.closest('[data-nyl-open]');
    if (o) { if (open(o.getAttribute('data-nyl-open'), o)) e.preventDefault(); return; }
    if (e.target.closest('[data-nyl-close]')) { e.preventDefault(); close(); }
  });
  on(d, 'keydown', function (e) {
    if (!openDrawer) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = focusables($('.nyl-drawer__panel', openDrawer)); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Cart (Shopify AJAX Cart API) ---------- */
  var routes = cfg.routes || {};
  var cartBase = (routes.cart || '/cart').replace(/\/$/, '');
  function renderCart(html) {
    if (!html) return;
    var tmp = d.createElement('div'); tmp.innerHTML = html;
    var fresh = $('[data-nyl-cart-contents]', tmp), cur = $('[data-nyl-cart-contents]');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    var countEl = $('[data-nyl-cart-count-src]', tmp);
    if (countEl) setCount(parseInt(countEl.getAttribute('data-nyl-cart-count-src'), 10) || 0);
  }
  function setCount(n) {
    $$('[data-nyl-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = n < 1; });
    $$('[data-nyl-cart-label]').forEach(function (a) { a.setAttribute('aria-label', (a.getAttribute('data-nyl-cart-label') || 'Cart') + ', ' + n + (n === 1 ? ' item' : ' items')); });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body), credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status && j.status >= 400) { var err = new Error(j.description || j.message || 'Something went wrong. Please try again.'); err.data = j; throw err; } return j; }); });
  }
  function refreshCart() {
    return fetch((routes.root || '/') + '?sections=nyl-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { renderCart(j['nyl-cart-drawer']); }).catch(function () {});
  }
  function cartError(msg) { var e = $('[data-nyl-cart-error]'); if (e) e.textContent = msg || ''; }
  function addToCart(items) {
    return post(cartBase + '/add.js', { items: items, sections: 'nyl-cart-drawer', sections_url: location.pathname })
      .then(function (j) {
        if (j.sections && j.sections['nyl-cart-drawer']) renderCart(j.sections['nyl-cart-drawer']); else return refreshCart();
      })
      .then(function () {
        cartError('');
        d.dispatchEvent(new CustomEvent('nyl:cart:added', { detail: { items: items } }));
        if (cfg.cartMode === 'page') { location.href = cartBase; return; }
        if (!open('cart')) location.href = cartBase;
      });
  }
  window.NylCart = { add: addToCart, refresh: refreshCart };
  function changeLine(line, qty) {
    var body = $('[data-nyl-cart-body]'); if (body) body.classList.add('is-busy');
    return post(cartBase + '/change.js', { line: line, quantity: qty, sections: 'nyl-cart-drawer', sections_url: location.pathname })
      .then(function (j) { if (j.sections) renderCart(j.sections['nyl-cart-drawer']); else return refreshCart(); cartError(''); })
      .catch(function (err) { cartError(err.message); return refreshCart(); })
      .then(function () { var b = $('[data-nyl-cart-body]'); if (b) b.classList.remove('is-busy'); });
  }
  on(d, 'click', function (e) {
    var b = e.target.closest('[data-nyl-line-qty]');
    if (b) { e.preventDefault(); changeLine(parseInt(b.getAttribute('data-line'), 10), parseInt(b.getAttribute('data-nyl-line-qty'), 10)); }
  });
  // Keep header count & drawer correct after back/forward cache restores.
  on(window, 'pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* ---------- Rails / carousels ---------- */
  function initRails(scope) {
    $$('[data-nyl-rail]', scope).forEach(function (rail) {
      if (rail._nyl) return; rail._nyl = 1;
      var track = $('[data-nyl-rail-track]', rail), prev = $('[data-nyl-rail-prev]', rail), next = $('[data-nyl-rail-next]', rail), bar = $('[data-nyl-rail-bar]', rail);
      if (!track) return;
      function step() { var c = track.firstElementChild; var gap = parseFloat(getComputedStyle(track).columnGap) || 20; return c ? c.getBoundingClientRect().width + gap : track.clientWidth * .8; }
      function upd() {
        var max = track.scrollWidth - track.clientWidth;
        var share = track.clientWidth / Math.max(1, track.scrollWidth);
        var p = max > 2 ? share + (1 - share) * (track.scrollLeft / max) : 1;
        if (bar) bar.style.setProperty('--p', Math.min(1, p).toFixed(3));
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }
      on(prev, 'click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      on(next, 'click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      on(track, 'scroll', upd, { passive: true }); on(window, 'resize', upd); upd();
      on(track, 'keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step() }); } if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step() }); } });
    });
  }

  /* ---------- Accordions ---------- */
  on(d, 'click', function (e) {
    var b = e.target.closest('[data-nyl-acc]');
    if (!b) return;
    var openNow = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', openNow ? 'true' : 'false');
  });
  function openAccFromHash() {
    var h = location.hash && location.hash.slice(1); if (!h) return;
    var t = d.getElementById(h); if (!t) return;
    var b = t.matches('[data-nyl-acc]') ? t : $('[data-nyl-acc]', t);
    if (b) b.setAttribute('aria-expanded', 'true');
  }

  /* ---------- Video ---------- */
  function initVideos(scope) {
    $$('[data-nyl-video]', scope).forEach(function (w) {
      if (w._nyl) return; w._nyl = 1;
      var v = $('video', w), t = $('[data-nyl-video-toggle]', w); if (!v) return;
      if (w.hasAttribute('data-autoplay') && !reduce) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      function sync() { if (t) { t.textContent = v.paused ? (t.getAttribute('data-play') || 'Play') : (t.getAttribute('data-pause') || 'Pause'); t.setAttribute('aria-pressed', v.paused ? 'false' : 'true'); } }
      on(t, 'click', function () { if (v.paused) v.play(); else v.pause(); });
      on(v, 'play', sync); on(v, 'pause', sync); sync();
    });
  }

  /* ---------- Newsletter (Shopify customer form) ---------- */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  on(d, 'submit', function (e) {
    var f = e.target.closest('[data-nyl-news]'); if (!f) return;
    var inp = $('input[type=email]', f), msg = f.parentNode.querySelector('[data-nyl-news-msg]');
    var val = (inp.value || '').trim(); inp.value = val;
    if (!EMAIL_RE.test(val)) {
      e.preventDefault();
      inp.setAttribute('aria-invalid', 'true');
      if (msg) { msg.textContent = f.getAttribute('data-invalid') || 'Enter a valid email address.'; msg.className = 'nyl-news__msg nyl-news__msg--err'; }
      inp.focus(); return;
    }
    inp.removeAttribute('aria-invalid');
    var btn = $('button[type=submit]', f); if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-loading') || '…'; }
  });

  /* ---------- Product forms ---------- */
  function Product(rootEl) {
    var self = this;
    this.el = rootEl;
    var json = $('[data-nyl-product-json]', rootEl);
    try { this.data = JSON.parse(json.textContent); } catch (e) { return; }
    this.idInput = $('input[name="id"]', rootEl);
    this.atc = $$('[data-nyl-atc]', rootEl.closest('[data-nyl-product-scope]') || rootEl);
    this.updateUrl = rootEl.hasAttribute('data-update-url');
    this.current = this.data.variants.filter(function (v) { return String(v.id) === String(self.idInput && self.idInput.value); })[0] || null;
    this.selected = this.current ? this.current.options.slice() : this.data.options.map(function () { return null; });
    $$('[data-nyl-opt]', rootEl).forEach(function (btn) {
      on(btn, 'click', function () { self.select(parseInt(btn.getAttribute('data-nyl-opt'), 10), btn.getAttribute('data-value')); });
      on(btn, 'keydown', function (e) {
        if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) < 0) return;
        e.preventDefault();
        var grp = $$('[data-nyl-opt="' + btn.getAttribute('data-nyl-opt') + '"]', rootEl);
        var i = grp.indexOf(btn) + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1);
        var n = grp[(i + grp.length) % grp.length]; n.focus(); n.click();
      });
    });
    var form = $('form[data-nyl-form]', rootEl.closest('[data-nyl-product-scope]') || rootEl);
    this.form = form;
    this.qty = $('[data-nyl-qty-input]', rootEl);
    $$('[data-nyl-qty-step]', rootEl).forEach(function (b) {
      on(b, 'click', function () { var q = self.qty; if (!q) return; var v = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-nyl-qty-step'), 10)); q.value = v; self.syncQty(); });
    });
    if (this.qty) on(this.qty, 'change', function () { self.qty.value = Math.max(1, parseInt(self.qty.value, 10) || 1); self.syncQty(); });
    this.atc.forEach(function (b) {
      on(b, 'click', function (e) { e.preventDefault(); self.add(b); });
    });
    if (form) on(form, 'submit', function (e) { e.preventDefault(); self.add(self.atc[0]); });
    this.gallery = rootEl.closest('[data-nyl-product-scope]') ? $('[data-nyl-gallery]', rootEl.closest('[data-nyl-product-scope]')) : null;
    this.render(true);
  }
  Product.prototype.syncQty = function () { var v = this.qty ? this.qty.value : 1; $$('[data-nyl-qty-dec]', this.el).forEach(function (b) { b.disabled = parseInt(v, 10) <= 1; }); };
  Product.prototype.find = function (sel) {
    return this.data.variants.filter(function (v) { return v.options.every(function (o, i) { return sel[i] === o; }); })[0] || null;
  };
  Product.prototype.select = function (i, val) {
    this.selected[i] = val;
    var v = this.find(this.selected);
    if (!v) { // keep the chosen value; pick the closest available combination for the other options
      var self = this;
      v = this.data.variants.filter(function (x) { return x.options[i] === val && x.available; })[0] || this.data.variants.filter(function (x) { return x.options[i] === val; })[0];
      if (v) this.selected = v.options.slice();
    }
    this.current = v; this.render(false);
  };
  Product.prototype.render = function (initial) {
    var self = this, v = this.current, data = this.data, rootEl = this.el;
    // option buttons + labels + availability markers
    data.options.forEach(function (name, i) {
      $$('[data-nyl-opt="' + i + '"]', rootEl).forEach(function (b) {
        var val = b.getAttribute('data-value'), active = self.selected[i] === val;
        b.setAttribute('aria-checked', active ? 'true' : 'false'); b.tabIndex = active || (!self.selected[i] && b === b.parentNode.firstElementChild) ? 0 : -1;
        var test = self.selected.slice(); test[i] = val;
        var match = self.find(test);
        var avail = match ? match.available : data.variants.some(function (x) { return x.options[i] === val && x.available; });
        b.classList.toggle('is-unavailable', !avail);
        var lbl = b.getAttribute('data-label') || val;
        b.setAttribute('aria-label', lbl + (avail ? '' : ' — ' + (cfg.strings && cfg.strings.unavailable || 'unavailable')));
      });
      $$('[data-nyl-opt-label="' + i + '"]', rootEl).forEach(function (l) { l.textContent = self.selected[i] || ''; });
    });
    var scope = rootEl.closest('[data-nyl-product-scope]') || rootEl;
    if (this.idInput) this.idInput.value = v ? v.id : '';
    // price
    $$('[data-nyl-price]', scope).forEach(function (p) { p.textContent = v ? formatMoney(v.price) : ''; });
    $$('[data-nyl-compare]', scope).forEach(function (p) { var show = v && v.compare_at_price > v.price; p.hidden = !show; p.textContent = show ? formatMoney(v.compare_at_price) : ''; });
    $$('[data-nyl-save]', scope).forEach(function (p) {
      var show = v && v.compare_at_price > v.price; p.hidden = !show;
      if (show) { var diff = v.compare_at_price - v.price; var tpl = p.getAttribute('data-template') || 'Save [amount]'; p.textContent = tpl.replace('[amount]', formatMoney(diff)).replace('[percent]', Math.round(diff * 100 / v.compare_at_price) + '%'); }
    });
    // stock
    $$('[data-nyl-stock]', scope).forEach(function (s) {
      var state = !v ? 'unavailable' : !v.available ? 'soldout' : (v.managed && v.qty <= 0) ? 'backorder' : 'instock';
      s.setAttribute('data-state', state);
      var t = $('[data-nyl-stock-text]', s); if (t) t.textContent = s.getAttribute('data-' + state) || '';
      s.hidden = !t || !t.textContent;
    });
    // buttons
    var ok = !!(v && v.available);
    this.atc.forEach(function (b) {
      b.disabled = !ok; b.setAttribute('aria-disabled', ok ? 'false' : 'true');
      var lab = $('[data-nyl-atc-label]', b) || b;
      lab.textContent = !v ? (b.getAttribute('data-unavailable') || 'Unavailable') : !v.available ? (b.getAttribute('data-soldout') || 'Sold out') : (b.getAttribute('data-add') || 'Add to cart').replace('[price]', formatMoney(v.price));
    });
    // sticky labels
    $$('[data-nyl-variant-title]', scope).forEach(function (t) { t.textContent = v ? v.title : ''; });
    $$('[data-nyl-sticky-thumb]', scope).forEach(function (img) { var src = self.thumbFor(v); if (src) img.src = src; });
    // url
    if (this.updateUrl && v && !initial) {
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({ variant: v.id }, '', u.toString()); } catch (e) {}
    }
    this.filterGallery(initial);
    this.syncQty();
    rootEl.dispatchEvent(new CustomEvent('nyl:variant', { bubbles: true, detail: { variant: v } }));
  };
  Product.prototype.colorValue = function () {
    var ci = this.data.colorIndex; if (ci == null || ci < 0) return null; return this.selected[ci];
  };
  Product.prototype.thumbFor = function (v) {
    var g = this.gallery; if (!g) return v && v.image;
    var grp = handle(this.colorValue() || '');
    var s = $('[data-group="' + grp + '"] img', g) || $('[data-group="shared"] img', g);
    return s ? (s.currentSrc || s.src) : (v && v.image);
  };
  function handle(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  Product.prototype.filterGallery = function (initial) {
    var g = this.gallery; if (!g || !g._nyl) return;
    var cv = this.colorValue() || ''; g._nyl.show(handle(cv), initial, cv);
  };
  Product.prototype.add = function (btn) {
    var self = this, v = this.current;
    var err = $('[data-nyl-atc-error]', this.el.closest('[data-nyl-product-scope]') || this.el);
    if (!v || !v.available) { if (err) err.textContent = (cfg.strings && cfg.strings.unavailable_long) || 'This combination is unavailable.'; return; }
    var qty = this.qty ? Math.max(1, parseInt(this.qty.value, 10) || 1) : 1;
    var buttons = this.atc; buttons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); var l = $('[data-nyl-atc-label]', b) || b; l._txt = l.textContent; l.textContent = b.getAttribute('data-adding') || 'Adding…'; });
    if (err) err.textContent = '';
    addToCart([{ id: v.id, quantity: qty }])
      .catch(function (e) { if (err) err.textContent = e.message; else toast(e.message); })
      .then(function () { buttons.forEach(function (b) { b.removeAttribute('aria-busy'); }); self.render(true); });
  };

  /* ---------- Gallery + lightbox ---------- */
  function Gallery(g) {
    var self = this; this.g = g; g._nyl = this;
    this.track = $('[data-nyl-gal-track]', g); this.count = $('[data-nyl-gal-count]', g); this.dots = $('[data-nyl-gal-dots]', g);
    this.more = $('[data-nyl-gal-more]', g); this.initial = parseInt(g.getAttribute('data-initial'), 10) || 4; this.expanded = false;
    on(this.track, 'scroll', function () { self.onScroll(); }, { passive: true });
    on(this.more, 'click', function () { self.expanded = !self.expanded; self.layout(); if (!self.expanded) g.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); });
    on(g, 'click', function (e) { var z = e.target.closest('[data-nyl-zoom]'); if (z) { e.preventDefault(); self.openLb(self.visible().indexOf(z.closest('.nyl-gal__slide'))); } });
    this.lb = $('[data-nyl-lb]', g);
    if (this.lb) {
      d.body.appendChild(this.lb);
      on($('[data-nyl-lb-close]', this.lb), 'click', function () { self.closeLb(); });
      on($('[data-nyl-lb-prev]', this.lb), 'click', function () { self.lbGo(-1); });
      on($('[data-nyl-lb-next]', this.lb), 'click', function () { self.lbGo(1); });
      on($('[data-nyl-lb-img]', this.lb), 'click', function (e) { if (e.target.tagName === 'IMG') this.classList.toggle('is-zoomed'); });
      on(this.lb, 'keydown', function (e) { if (e.key === 'Escape') self.closeLb(); if (e.key === 'ArrowRight') self.lbGo(1); if (e.key === 'ArrowLeft') self.lbGo(-1); });
      var sx = null;
      on(this.lb, 'touchstart', function (e) { if (e.touches.length === 1) sx = e.touches[0].clientX; }, { passive: true });
      on(this.lb, 'touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if ($('[data-nyl-lb-img]', self.lb).classList.contains('is-zoomed')) return; if (Math.abs(dx) > 50) self.lbGo(dx < 0 ? 1 : -1); });
    }
    this.group = g.getAttribute('data-start-group') || 'shared';
  }
  Gallery.prototype.slides = function () { return $$('.nyl-gal__slide', this.track); };
  Gallery.prototype.visible = function () { return this.slides().filter(function (s) { return !s.hidden; }); };
  Gallery.prototype.show = function (grp, initial, val) {
    var has = this.slides().some(function (s) { return s.getAttribute('data-group') === grp; });
    var use = has ? grp : (grp ? 'fallback' : 'shared');
    var self = this, sharedAlso = this.g.hasAttribute('data-shared-always');
    this.slides().forEach(function (s) {
      var sg = s.getAttribute('data-group');
      var showIt = sg === use || (sg === 'shared' && (sharedAlso || use === 'fallback' && !self.slides().some(function (x) { return x.getAttribute('data-group') === 'fallback'; })));
      if (use === 'fallback' && sg === 'fallback') { var sw = s.querySelector('[data-nyl-fallback]'); if (sw) self.fillFallback(sw, val); }
      s.hidden = !showIt;
    });
    this.expanded = initial ? this.expanded : false;
    if (!initial && this.track) this.track.scrollTo({ left: 0 });
    this.layout();
  };
  Gallery.prototype.fillFallback = function (el, val) {
    var sw = (window.NylSwatches || {})[handle(val)] || '#ccc';
    el.style.setProperty('--sw', sw); var n = $('[data-nyl-fallback-name]', el); if (n) n.textContent = val || '';
  };
  Gallery.prototype.layout = function () {
    var vis = this.visible(), init = this.initial, ex = this.expanded;
    vis.forEach(function (s, i) { s.classList.toggle('is-extra', i >= init); s.classList.toggle('is-shown', ex); var img = $('img', s); if (img && i === 0) { img.loading = 'eager'; } });
    this.g.classList.toggle('nyl-gal--one', vis.length === 1);
    if (this.more) {
      var extra = vis.length - init; this.more.parentNode.hidden = extra <= 0;
      this.more.textContent = ex ? (this.more.getAttribute('data-less') || 'Show less') : (this.more.getAttribute('data-more') || 'Load more images ([count])').replace('[count]', extra);
      this.more.setAttribute('aria-expanded', ex ? 'true' : 'false');
    }
    if (this.dots) { this.dots.innerHTML = vis.length > 1 ? vis.map(function () { return '<span></span>'; }).join('') : ''; }
    this.onScroll();
  };
  Gallery.prototype.onScroll = function () {
    var vis = this.visible(); if (!this.track || !vis.length) return;
    var i = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth)); i = Math.max(0, Math.min(vis.length - 1, i));
    if (this.count) { this.count.textContent = (i + 1) + ' / ' + vis.length; this.count.hidden = vis.length < 2; }
    if (this.dots) $$('span', this.dots).forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
  };
  Gallery.prototype.openLb = function (i) {
    if (!this.lb) return; this.lbI = Math.max(0, i); this.lbFocus = d.activeElement;
    this.lb.classList.add('is-open'); this.lb.setAttribute('aria-hidden', 'false'); d.body.style.overflow = 'hidden'; this.lbShow();
    $('[data-nyl-lb-close]', this.lb).focus();
  };
  Gallery.prototype.lbShow = function () {
    var vis = this.visible().filter(function (s) { return s.querySelector('[data-full]'); });
    if (!vis.length) return; this.lbI = (this.lbI + vis.length) % vis.length;
    var src = vis[this.lbI].querySelector('[data-full]');
    var box = $('[data-nyl-lb-img]', this.lb); box.classList.remove('is-zoomed');
    box.innerHTML = '<img src="' + src.getAttribute('data-full') + '" alt="' + (src.getAttribute('alt') || '').replace(/"/g, '&quot;') + '">';
    $('[data-nyl-lb-count]', this.lb).textContent = (this.lbI + 1) + ' / ' + vis.length;
    var many = vis.length > 1; $('[data-nyl-lb-prev]', this.lb).hidden = !many; $('[data-nyl-lb-next]', this.lb).hidden = !many;
  };
  Gallery.prototype.lbGo = function (n) { this.lbI += n; this.lbShow(); };
  Gallery.prototype.closeLb = function () { this.lb.classList.remove('is-open'); this.lb.setAttribute('aria-hidden', 'true'); d.body.style.overflow = ''; if (this.lbFocus) this.lbFocus.focus(); };

  /* ---------- Sticky purchase bar ---------- */
  function initSticky(scope) {
    $$('[data-nyl-sticky]', scope).forEach(function (bar) {
      if (bar._nyl) return; bar._nyl = 1;
      var target = d.getElementById(bar.getAttribute('data-target'));
      if (!target) return;
      var drawerOpen = false, ticking = false;
      function upd() {
        ticking = false;
        var footer = $('.nyl-foot') || $('footer');
        var past = target.getBoundingClientRect().bottom < 0;
        var footVis = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        var show = past && !footVis && !drawerOpen && getComputedStyle(bar).display !== 'none';
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if ('inert' in bar) bar.inert = !show;
      }
      function req() { if (!ticking) { ticking = true; requestAnimationFrame(upd); setTimeout(function () { if (ticking) upd(); }, 120); } }
      on(window, 'scroll', req, { passive: true });
      on(window, 'resize', req);
      on(d, 'nyl:drawer', function (e) { drawerOpen = e.detail.open; upd(); });
      upd();
    });
  }

  /* ---------- Boot ---------- */
  function boot(scope) {
    initReveal(scope); initRails(scope); initVideos(scope); initSticky(scope);
    $$('[data-nyl-gallery]', scope).forEach(function (g) { if (!g._nyl) new Gallery(g); });
    $$('[data-nyl-product]', scope).forEach(function (p) { if (!p._nyl) p._nyl = new Product(p); });
  }
  function start() { initHeader(); boot(d); openAccFromHash(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
  on(window, 'hashchange', openAccFromHash);
  // Theme editor: re-initialise sections as they are added, changed or reordered.
  on(d, 'shopify:section:load', function (e) { boot(e.target); initHeader(); });
  on(d, 'shopify:block:select', function (e) {
    var b = e.target; var acc = b.matches('[data-nyl-acc-wrap]') ? $('[data-nyl-acc]', b) : null; if (acc) acc.setAttribute('aria-expanded', 'true');
    var slide = b.closest('[data-nyl-rail-track]'); if (slide) b.scrollIntoView({ block: 'nearest', inline: 'start' });
  });
  on(d, 'shopify:section:select', function (e) { if (e.target.querySelector('#nyl-drawer-cart')) open('cart'); });
  on(d, 'shopify:section:deselect', function (e) { if (e.target.querySelector('#nyl-drawer-cart')) close(); });
})();
